/**
 * Form alanlarını sunucudaki /api/contact servisine gönderir (Gmail SMTP ile mail'e çevrilir).
 * @param {HTMLFormElement} form
 * @param {string} [formType] form içinde hidden `form_type` yoksa kullanılır
 * @returns {Promise<void>}
 */
export async function submitForm(form, formType) {
    const fields = {};
    new FormData(form).forEach((value, key) => {
        if (typeof value === "string") {
            fields[key] = value;
        }
    });
    if (formType && !fields.form_type) {
        fields.form_type = formType;
    }

    const response = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(fields),
    });
    if (!response.ok) {
        throw new Error(`Form gönderilemedi (${response.status})`);
    }
}
